import React, { useEffect } from 'react';
import { Pane, TickCircleIcon, ArrowLeftIcon } from 'evergreen-ui';
import styles from './CompleteBooking.module.css';
import { ButtonLink } from '../../components';

const NonPayableScreen = ({ subdomain, booking, course }) => {
    useEffect(() => {
        if (booking) {
            window.analytics.track('Complete Booking Failure - ', {
                booking_id: booking._id,
                content_ids: [booking._id],
                contents: [{ id: booking._id, payment_status: booking.payment_status }],
                payment_status: booking.payment_status,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const backToCoursesCta = () => {
        return (
            <ButtonLink to="/" margin="0 10px 0 0">
                <ArrowLeftIcon marginRight={10} />
                Back to course list
            </ButtonLink>
        );
    };

    return (
        <>
            <Pane>
                <Pane
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    textAlign="center"
                    marginTop={30}
                >
                    <TickCircleIcon color="success" size={100} />
                    <h1>Unable to continue</h1>
                    <p>
                        You booking is in the '{booking.payment_status}' status and you are
                        therefore unable to complete this booking.
                    </p>

                    <Pane className={styles.confirmation_screen_buttons}>{backToCoursesCta()}</Pane>
                </Pane>
            </Pane>
        </>
    );
};

export default NonPayableScreen;
